import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Register from './pages/register2';
import CameraWithFrame from './pages/selfie';
import CaptureAndDisplay from './pages/selfiepage';
// import ShareButton from './pages/share'

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<Register/>} />
          <Route path="/selfie" element={<CaptureAndDisplay/>} />
          {/* <Route path="/share" element={<ShareButton/>} /> */}


        </Routes>
      </Router>
    </div>
  );
}

export default App;
